import React from 'react'
import { NavLink } from 'react-router-dom'

import AppBar from '@mui/material/AppBar'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

import MenuIcon from '@mui/icons-material/Menu'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'

import { useAuth } from '../../contexts/AuthContext'
import { useRecordLock } from '../../contexts/RecordLockContext'
import { useSideNav } from '../../contexts/SideNavOpenContext'

import VersionDetails from './VersionDetails'

import logo from '../../img/favicon-32x32.png'
import NavSide from './NavSide'

const Nav = () => {
  const { sideNavOpen, setSideNavOpen } = useSideNav(true)
  const { recordLock } = useRecordLock()
  const { user, login, logout, isAuth } = useAuth()

  const toggleOpen = () => {
    setSideNavOpen(!sideNavOpen)
  }

  return (
    <>
      <AppBar
        position='static'
        sx={{
          backgroundColor: '#ececec',
          color: 'black',
          position: 'fixed',
          top: 0,
          zIndex: 12001,
        }}
      >
        <Grid container sx={{ p: 1.5 }}>
          {isAuth && (
            <Grid item sx={{ mx: 1 }}>
              {sideNavOpen ? (
                <IconButton onClick={toggleOpen}>
                  <ChevronLeftIcon />
                </IconButton>
              ) : (
                <IconButton onClick={toggleOpen}>
                  <MenuIcon />
                </IconButton>
              )}
            </Grid>
          )}
          {!recordLock ? (
            <Grid item sx={{ mx: 1 }}>
              <img alt='logo' src={logo} />
            </Grid>
          ) : (
            <NavLink to='/'>
              <Grid item sx={{ mx: 1 }}>
                <img alt='logo' src={logo} />
              </Grid>
            </NavLink>
          )}
          <Grid item sx={{ flexGrow: 1, mt: 0.5 }}>
            <Box sx={{ display: 'inline', fontWeight: 'bold' }}>SUPER</Box>
            <Box sx={{ display: 'inline', fontWeight: 'light' }}>
              connection
            </Box>
            <Box sx={{ fontSize: '9px' }}>An HDMconnections Application</Box>
          </Grid>

          {recordLock ? (
            <>
              {isAuth && <VersionDetails />}

              <Grid item sx={{ mt: 0.7 }}>
                {user && <Typography>{user.email}</Typography>}
              </Grid>
              <Grid item>
                {isAuth ? (
                  <Button color='inherit' onClick={logout}>
                    Logout
                  </Button>
                ) : (
                  <Button color='inherit' onClick={login}>
                    Login
                  </Button>
                )}
              </Grid>
            </>
          ) : (
            <>
              <Grid item sx={{ flexGrow: 2, mt: 0.7 }}>
                <Typography sx={{ fontWeight: 'bold' }}>
                  You are in edit mode. Save or Cancel (bottom of screen) to
                  proceed.
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </AppBar>
      {isAuth && <NavSide sideNavOpen={sideNavOpen} />}
    </>
  )
}

export default Nav
